import { StaticRole } from '@markant-platform/shared/user/model';

export function getAdminRouteByRole(roles: string[]): string[] {
  if (roles.includes(StaticRole.PLATFORM_ADMIN)) {
    return ['/backoffice'];
  }
  if (roles.includes(StaticRole.ORGANIZATION_ADMIN) || roles.includes(StaticRole.ORGANIZATION_MANAGER)) {
    return ['/organization'];
  }
  if (roles.includes(StaticRole.LEISTUNG_ADMIN)) {
    return ['/cartridge-admin'];
  }
  return [];
}
